import type {
  GetConsent,
  GetConsentStatement,
  PostConsent,
} from "@/server-types";
import { CONSENT_VERSION, readSessionToken } from "@/utils/consent";
import { useCustomMutation } from "../custom-mutation";
import { useCustomQuery } from "../custom-query";
import { get, post } from "../request-helpers";

export function useGetConsent(options?: { enabled?: boolean }) {
  return useCustomQuery({
    // Scope by session token so a different user in the same tab (login without a
    // full reload) never reconciles against the previous user's cached snapshot.
    queryKey: ["consent", readSessionToken()],
    queryFn: () => get<GetConsent>("/consent"),
    enabled: options?.enabled,
  });
}

/**
 * The statement the banner must display, fetched rather than written here so
 * the wording a user reads is the string the consent ledger stores.
 */
export function useGetConsentStatement(
  language: GetConsentStatement["query"]["language"],
) {
  return useCustomQuery({
    queryKey: ["consent-statement", "dashboard", language],
    queryFn: () =>
      get<GetConsentStatement>("/public/consent-statement", {
        surface: "dashboard",
        version: CONSENT_VERSION,
        language,
      }),
    staleTime: Number.POSITIVE_INFINITY,
  });
}

export function usePostConsent() {
  return useCustomMutation({
    mutationFn: (body: PostConsent["body"]) =>
      post<PostConsent>("/consent", body),
  });
}
